import HTTP from "@/_helpers/http";
import { NEWUSER__API } from "@/_helpers/urls";
import { NEWUSER__MUTATIONS } from "../mutation-types";
import { NEWUSER__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

function filterObject(obj) {
  return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
}

// State
const state = {
  isUserCreated: false,
  step: 1,
};

// Getters
const getters = {};

// Mutations
const mutations = {
  [NEWUSER__MUTATIONS.NEWUSER](state, data) {
    state.states = data;
  },
  SET_STEP(state, step) {
    state.step = step;
  },
  SET_USERCREATED_STATUS(state, status) {
    state.isUserCreated = status;
  },
};

// Actions
const actions = {
  async [NEWUSER__ACTIONS.NEWUSER]({ commit, state }, parameter) {
    try {
      const formData = new FormData();

      const filteredParameter = filterObject(parameter);
      for (const [key, value] of Object.entries(filteredParameter)) {
        formData.append(key, value);
      }

      const response = await HTTP().post(NEWUSER__API.NEWUSER, formData);
      if (response.status === 200) {
        toast.success("Account Creation successfull");
        commit("SET_STEP", 1);
        commit("SET_USERCREATED_STATUS", true);
      }
    } catch (error) {
      commit("SET_USERCREATED_STATUS", false);
      toast.error("Account Creation failed:", error.message);
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
